export interface TrackedRequest {
	isCurrent: () => boolean;
}

export function createRequestTracker() {
	let version = 0;

	function start(): TrackedRequest {
		version++;
		return capture();
	}

	function capture(): TrackedRequest {
		const requestVersion = version;

		function isCurrent() {
			return requestVersion === version;
		}

		return { isCurrent };
	}

	function invalidate() {
		version++;
	}

	return { capture, invalidate, start };
}
